import { CURRENT_WORKSPACE_ID, isBrowser } from "@/utils/local_storage_keys";

/**
 * External deep-links (Slack / email notifications) can target a specific
 * workspace via `?redirect_workspace_id=<id>` so the link opens against the
 * right workspace even when the recipient was last active in a different one.
 *
 * We consume it *before* React renders (called from main.tsx) so it wins the
 * race with every workspace-scoped query: `use-current-user` reads the freshly
 * stored id on its first fetch, and if the recipient turns out not to have
 * access it already falls back to their first accessible workspace. The param
 * is then stripped so it doesn't linger in the URL or leak into shared links.
 *
 * Runs synchronously and pre-render, so no reload is needed — the app boots
 * once, in the correct workspace.
 */
export function applyRedirectWorkspaceFromUrl(): void {
  if (!isBrowser) return;

  const url = new URL(window.location.href);
  const requested = url.searchParams.get("redirect_workspace_id");
  if (!requested) return;

  if (requested !== localStorage.getItem(CURRENT_WORKSPACE_ID)) {
    localStorage.setItem(CURRENT_WORKSPACE_ID, requested);
  }

  url.searchParams.delete("redirect_workspace_id");
  window.history.replaceState(
    window.history.state,
    "",
    url.pathname + url.search + url.hash,
  );
}
